"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _edit = _interopRequireDefault(require("../coupons/edit.vue"));
var _selectCompay = _interopRequireDefault(require("../coupons/selectCompay.vue"));
var _capitalRecord = _interopRequireDefault(require("../coupons/capitalRecord.vue"));
var _settingEdit = _interopRequireDefault(require("../coupons/settingEdit.vue"));
var _editBrank = _interopRequireDefault(require("../coupons/editBrank.vue"));
var _settingProduct = _interopRequireDefault(require("../coupons/settingProduct.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    edit: _edit.default,
    SelectCompay: _selectCompay.default,
    CapitalRecord: _capitalRecord.default,
    SettingEdit: _settingEdit.default,
    EditBrank: _editBrank.default,
    SettingProduct: _settingProduct.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      addresData: [],
      typeOpetion: [{
        value: 1,
        label: '待联系'
      }, {
        value: 2,
        label: '初次联系无回复'
      }, {
        value: 3,
        label: '资料收集'
      }, {
        value: 4,
        label: '商务洽谈'
      }, {
        value: 5,
        label: '签订合同'
      }, {
        value: 6,
        label: '合同终止'
      }],
      cardOpetion: [{
        id: 1,
        label: '无票'
      }, {
        id: 2,
        label: '普票'
      }, {
        id: 3,
        label: '专票'
      }, {
        id: 4,
        label: '混合票种'
      }],
      userOption: [],
      maintainerOptions: [],
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      editDialogConfig: {
        visible: false,
        editId: 0,
        isEdit: 0 // 0=add 1=edit
      },
      settingDialogConfig: {
        visible: false,
        editId: 0
      },
      listLoading: true,
      categoryTreeData: [],
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      },
      operationPlatform: [],
      //运营平台
      miniProgramCustomer: false //是否为小程序客户
    };
  },
  created: function created() {
    // this.getCityList();
    this.getSelectUser();
    this.getMaintainerList();
    this.miniProgramCustomer = suplierCouponsApi.getHomeType();
  },
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.handlerGetTreeList();
    this.getOperationPlatform();
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    //获取运营平台数据
    getOperationPlatform: function getOperationPlatform() {
      var _this = this;
      suplierCouponsApi.getOperationPlatform().then(function (data) {
        console.log("运营平台数据", data);
        _this.operationPlatform = data;
      });
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this2 = this;
      categoryApi.listCategroy({
        type: 3,
        status: ''
      }).then(function (data) {
        _this2.categoryTreeData = data.list;
        localStorage.setItem('articleClass', JSON.stringify(data.list));
      });
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this3 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      suplierCouponsApi.ListArticle(_objectSpread(_objectSpread({}, pram), {}, {
        supplierType: 2
      })).then(function (data) {
        _this3.listData = data;
        _this3.listLoading = false;
      }).catch(function (err) {
        _this3.listLoading = false;
      });
    },
    handlerOpenSetting: function handlerOpenSetting(editId) {
      this.settingDialogConfig.editId = editId;
      this.settingDialogConfig.visible = true;
    },
    handlerOpenEdit: function handlerOpenEdit(editId) {
      this.editDialogConfig.isEdit = Boolean(editId);
      this.editDialogConfig.editId = editId;
      this.editDialogConfig.visible = true;
    },
    handlerHideDialog: function handlerHideDialog() {
      this.handlerGetListData(this.listPram);
      this.editDialogConfig.visible = false;
      this.settingDialogConfig.visible = false;
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this4 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        suplierCouponsApi.DelArticle(rowData).then(function (data) {
          _this4.$message.success('删除数据成功');
          _this4.handlerGetListData(_this4.listPram);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    getCityList: function getCityList() {
      var _this5 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this5.addresData = res;
      }).catch(function (res) {
        _this5.$message.error(res.message);
      });
    },
    onchangeIsShow: function onchangeIsShow(row, status) {
      var _this6 = this;
      var changeState = status == 1 ? 2 : 1;
      suplierCouponsApi.UpdateArticle(_objectSpread(_objectSpread({}, row), {}, {
        changeState: changeState
      })).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this6.$message.success('修改成功');
              _this6.handlerGetListData();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))).catch(function () {
        row.status = changeState;
      });
    },
    selectCompany: function selectCompany(companyId) {
      this.$set(this.listPram, 'companyId', companyId);
      this.handerSearch();
    },
    openRecordList: function openRecordList(row) {
      this.$refs['CapitalRecordRef'].initOpen(row);
    },
    getSupplierAmt: function getSupplierAmt(row) {
      var _this7 = this;
      suplierCouponsApi.getAmt(row.id).then(function (res) {
        _this7.$alert('', '余额查询', {
          confirmButtonText: '确定'
        });
        _this7.$alert("<div style='font-size: 18px; font-weight: 500;'>\u5269\u4F59\u4F59\u989D\u4E3A\uFF1A<span style='color: red'>".concat(res || 0, "</span></sp></div>"), '余额查询', {
          dangerouslyUseHTMLString: true
        });
      });
    },
    // 关联品牌
    bindBrand: function bindBrand(supplierId) {
      this.$refs.editBrankRef.openInit(supplierId);
    },
    // 配置产品
    settingProduct: function settingProduct(row) {
      this.$refs['SettingProductRef'].initOpen(row);
    },
    // 查询当前登陆人
    getSelectUser: function getSelectUser(keyWord) {
      var _this8 = this;
      this.userOption = [];
      suplierCouponsApi.getAllUser(keyWord).then(function (res) {
        _this8.userOption = res || []; //flag: 1表示当前登陆人
      });
    },
    handleUserSearch: function handleUserSearch(data) {
      var _this9 = this;
      this.throttle(function () {
        _this9.getSelectUser(data);
      }, 300)();
    },
    // 获取维护人下拉列表
    getMaintainerList: function getMaintainerList() {
      var _this0 = this;
      suplierCouponsApi.getMaintainerList().then(function (res) {
        _this0.maintainerOptions = res || [];
      });
    },
    handleMaintainerSearch: function handleMaintainerSearch(data) {
      var _this1 = this;
      this.throttle(function () {
        suplierCouponsApi.getMaintainerList().then(function (res) {
          _this1.maintainerOptions = res || [];
        });
      }, 300)();
    }
  }
};